import { SearchConfig, SearchKey } from "../../../../types/search";

type OptionKeys = Extract<
  SearchKey,
  "name" | "phone" | "email" | "emiratesId" | "passport" | "tradeLicense" | "businessUnitId" | "ownerName"
>;

export const searchByOptions: SearchConfig<OptionKeys>[] = [
  { value: "name", label: "Name", controlType: "text", default: true },
  { value: "phone", label: "Phone", controlType: "text" },
  { value: "email", label: "Email", controlType: "text" },
  { value: "emiratesId", label: "Emirates ID", controlType: "text" },
  { value: "passport", label: "Passport No", controlType: "text" },
  { value: "tradeLicense", label: "Trade License No", controlType: "text" },
  { value: "businessUnitId", label: "Business Unit", controlType: "select" },
  { value: "ownerName", label: "Owner", controlType: "select" },
];
